<template>
    <select :class="cssClass" :id="id" :name="name" :disabled="disabled" :multiple="multiple"></select>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    //import 'select2'; //this does not import the full version of select2, we need to use the require statement below to accomplish that
    require("select2/dist/js/select2.full.js");
    
    export default {
        name: 'Select2',
        model: {
            event: 'change',
            prop: 'value'
        },
        props: {
            id: {
                type: String,
                default: null
            },
            name: {
                type: String,
                default: null
            },
            placeholder: {
                type: String,
                default: null
            },
            options: {
                type: Array,
                default: null
            },
            disableSearch: {
                type: Boolean,
                default: false
            },
            minSearchChars: {
                type: Number,
                default: 0
            },
            searchHint: {
                type: String,
                default: null
            },
            allowClear: {
                type: Boolean,
                default: false
            },
            enableAjax: {
                type: Boolean,
                default: false
            },
            keyProperty: {
                type: String,
                default: 'value'
            },
            textProperty: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: Boolean,
                default: false
            },
            tags: {
                type: Boolean,
                default: false
            },
            createTag: {
                type: Function,
                default: null
            },
            cssClass: {
                type: String,
                default: 'form-control'
            },
            dropdownCssClass: {
                type: String,
                default: null
            },
            initialFocus: {
                type: Boolean,
                default: false
            },
            state: {
                type: Boolean,
                default: null
            },
            theme: {
                type: String,
                default: 'bootstrap'
            },
            dropdownParent: {
                type: String,
                default: null
            },
            inBModal: {
                type: Boolean,
                default: false
            },
            renderOptionHtml: {
                type: Function,
                default: null
            },
            settings: {
                type: Object,
                default: function () {
                    return { containerCssClass: this.cssClass };
                }
            },
            value: null
        },
        data: function () {
            return {
                select2: null,
                currentOptions: this.options,
                currentValue: this.value
            }
        },
        watch: {
            options: function () {
                this.currentOptions = this.options;
                this.$_select2_updateSelect2();
                var newValue = null;
                if (this.currentOptions != null) {
                    var selectedValues = []
                    this.currentOptions.forEach(option => {
                        if (option.selected) {
                            if (typeof (option) == 'string') {
                                selectedValues.push(option);
                            } else if (this.keyPropery == null) {
                                selectedValues.push(option.id);
                            } else {
                                selectedValues.push(option.id || option[this.keyProperty]);
                            }
                        }
                    });
                    if (selectedValues.length > 0) {
                        if (this.multiple) {
                            newValue = selectedValues;
                        } else {
                            newValue = selectedValues[0];
                        }
                    }
                }
                this.select2.val(newValue);
                this.select2.trigger('change');
                if (this.$_select2_hasValueChanged(newValue)) {
                    this.currentValue = newValue;
                    this.$emit('change', this.currentValue);
                    var data = this.select2.select2('data');
                    if (!this.multiple && (data != null) && (data.length > 0)) data = data[0];
                    this.$emit('select', data);
                }
            },
            value: function () {
                if (this.$_select2_hasValueChanged(this.value)) {
                    this.currentValue = this.value;
                    if (this.currentValue == null) {
                        this.select2.val(null);
                    } else if (!this.multiple) {
                        if (this.currentValue instanceof Array) {
                            this.select2.val(this.currentValue[0]);
                        } else {
                            this.select2.val(this.currentValue);
                        }
                    } else {
                        if (this.currentValue instanceof Array) {
                            this.select2.val(this.currentValue);
                        } else {
                            this.select2.val([this.currentValue]);
                        }
                    }
                    this.select2.trigger('change');
                }
            },
            placeholder: function () {
                this.settings.placeholder = this.placeholder;
                this.$_select2_updateSelect2();
                this.select2.trigger('change');
            },
            cssClass: function () {
                this.$_select2_updateSelect2();
                this.select2.trigger('change');
            },
            dropdownCssClass: function () {
                this.$_select2_updateSelect2();
                this.select2.trigger('change');
            },
            state: function () {
                if (this.state == null) {
                    this.select2.removeClass('is-valid');
                    this.select2.removeClass('is-invalid');
                } else if (this.state) {
                    this.select2.addClass('is-valid');
                    this.select2.removeClass('is-invalid');
                } else {
                    this.select2.removeClass('is-valid');
                    this.select2.addClass('is-invalid');
                }
            }
        },
        methods: {
            focus: function(open = false) {
                this.select2.select2('focus');
                if (open) {
                    this.select2.select2('open');
                }
            },
            appendOption: function(option) {
                if (option != null) {
                    if (typeof (obj) == 'string') {
                        option = { id: option, text: option };
                    }
                    if (this.keyProperty != null) {
                        option.id = option.id || option[this.keyProperty];
                    }
                    if (this.textProperty != null) {
                        option.text = option.text || option[this.textProperty];
                    }
                    var newOption = new Option(option.text, option.id, false, false);
                    this.select2.append(newOption).trigger('change');
                }
            },
            getSelectedData: function() {
                return this.select2.select2('data');
            },
            setOptionsAndValue: function(options, value) {
                this.currentOptions = options;
                this.currentValue = value;
                this.refresh();
            },
            refresh: function() {
                this.$_select2_updateSelect2();
                if (this.currentValue == null) {
                    this.select2.val(null);
                } else if (!this.multiple) {
                    if (this.currentValue instanceof Array) {
                        this.select2.val(this.currentValue[0]);
                    } else {
                        this.select2.val(this.currentValue);
                    }
                } else {
                    if (this.currentValue instanceof Array) {
                        this.select2.val(this.currentValue);
                    } else {
                        this.select2.val([this.currentValue]);
                    }
                }
                this.select2.trigger('change');
            },
            //private
            $_select2_updateSelect2: function() {
                var mappedData = this.currentOptions;
                if (mappedData != null) {
                    if ((this.keyProperty == null) && (this.textProperty == null)) {
                        mappedData = $.map(mappedData, function (obj) {
                            if (typeof (obj) == 'string') {
                                obj = { id: obj, text: obj };
                            }
                            return obj;
                        });
                    }
                    if (this.keyProperty != null) {
                        var keyProperty = this.keyProperty;
                        mappedData = $.map(mappedData, function (obj) {
                            if (typeof (obj) == 'string') {
                                obj = { id: obj, text: obj };
                            } else {
                                obj.id = obj.id || obj[keyProperty];
                            }
                            return obj;
                        });
                    }
                    if (this.textProperty != null) {
                        var textProperty = this.textProperty;
                        mappedData = $.map(mappedData, function (obj) {
                            if (typeof (obj) == 'string') {
                                obj = { id: obj, text: obj };
                            } else {
                                obj.text = obj.text || obj[textProperty];
                            }
                            return obj;
                        });
                    }
                }
                var ajaxOptions = null;
                if (this.enableAjax) {
                    ajaxOptions = {
                        transport: this.$_select2_onSearch
                    };
                }
                this.select2.empty();
                var placeholder = this.placeholder;
                if (this.allowClear && (placeholder == null)) placeholder = ""; //there is a but in the select2 code that requires a placeholder other than null when the allowClear option is enabled
                var options = {
                    theme: this.theme,
                    placeholder: placeholder,
                    allowClear: this.allowClear,
                    minimumInputLength: this.minSearchChars,
                    ajax: ajaxOptions,
                    ...this.settings,
                    data: mappedData,
                    width: ''
                };
                if (this.dropdownCssClass) options.dropdownCssClass = this.dropdownCssClass;
                if (this.dropdownParent) options.dropdownParent = this.dropdownParent;
                else if (this.inBModal) {
                    if (this.select2.closest('.modal-body').length) options.dropdownParent = this.select2.closest('.modal-body');
                    else if (this.select2.closest('.modal-header').length) options.dropdownParent = this.select2.closest('.modal-header');
                    else if (this.select2.closest('.modal-footer').length) options.dropdownParent = this.select2.closest('.modal-footer');
                    else if (this.select2.closest('.modal-content').length) options.dropdownParent = this.select2.closest('.modal-content');
                }
                if (this.disableSearch) options.minimumResultsForSearch = 9999999999;
                if (this.searchHint) {
                    options.language = {
                        inputTooShort: () => {
                            return this.searchHint;
                        }
                    };
                }
                if (this.tags) {
                    options.tags = true;
                    options.createTag = this.$_select2_createTag;
                }
                if (this.renderOptionHtml) options.templateResult = this.$_select2_renderOption;
                this.select2.select2(options);
            },
            $_select2_selectionChanged: function () {
                var value = this.select2.val();
                if (this.$_select2_hasValueChanged(value)) {
                    this.currentValue = value;
                    this.$emit('change', value);
                    var data = this.select2.select2('data');
                    if (!this.multiple && (data != null) && (data.length > 0)) data = data[0];
                    this.$emit('select', data);
                }
            },
            $_select2_onSearch: function(params, success, failure) {
                this.$emit('search', params, success, failure);
            },
            $_select2_hasValueChanged: function (newValue) {
                if (newValue === this.currentValue) return false;
                if ((newValue == null) || (this.currentValue == null)) return true;
                if ((newValue instanceof Array) && (this.currentValue instanceof Array)) {
                    if (newValue.length == this.currentValue.length) {
                        for (var i = 0; i < newValue.length; i++) {
                            if (newValue[i] != this.currentValue[i]) return true;
                        }
                        return false;
                    }
                }
                return true;
            },
            $_select2_renderOption: function (option) {
                if (!option.id) return option.text;
                var optionHtmlText = this.renderOptionHtml(option);
                var optionHtmlObj = $(optionHtmlText);
                return optionHtmlObj;
            },
            $_select2_createTag: function (params) {
                if (!params.term) return null;
                var term = $.trim(params.term);
                if (term === '') return null;
                if (this.createTag != null) {
                    return this.createTag(term);
                }
                return {
                    id: term,
                    text: term
                }
            }

        },
        mounted: function() {
            this.select2 = $(this.$el).select2();
            this.select2.on('select2:select select2:unselect select2:close', this.$_select2_selectionChanged);
            this.refresh();
            if (this.initialFocus) this.focus();
            Vue.nextTick().then(() => {
                this.select2.trigger('change');
            });
        },
        beforeDestroy: function() {
            this.select2.select2('destroy');
        }
    }
</script>